const Token = require('markdown-it/lib/token');

function encodeNumberToInject(num) {
  return Number(num).toString(36);
}

function decodeInjectedNumber(str) {
  return parseInt(str, 36);
}

function getTokenInlinePosition(token) {
  if (!token.attrs) {
    return;
  }

  const attr = new Map(token.attrs);
  const inlinePosition = attr.get('data-md-inline');
  if (!inlinePosition) {
    return;
  }

  return inlinePosition.split(',').map(decodeInjectedNumber);
}

function injectTextWrapperToChildren(initialLine, children) {
  const newChildren = [];
  let currentPos = 0;

  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    const next = children[i + 1];

    if (child.type === 'text' && child.level === 0) {
      const spanOpen = new Token('span_open', 'span', 1);
      spanOpen.attrPush(['class', 'text-wrapper']);
      if (next) {
        const nextPos = getTokenInlinePosition(next);
        if (nextPos) {
          spanOpen.attrPush(['data-md-inline', `${encodeNumberToInject(currentPos)},${encodeNumberToInject(nextPos[0] - 1)}`]);
          currentPos = nextPos[0];
        }
      } else {
        const endPos = currentPos + child.content.length;
        spanOpen.attrPush(['data-md-inline', `${encodeNumberToInject(currentPos)},${encodeNumberToInject(endPos - 1)}`]);
        currentPos = endPos;
      }
      newChildren.push(spanOpen);

      child.level = 1;
      newChildren.push(child);

      const spanClose = new Token('span_close', 'span', -1);
      newChildren.push(spanClose);
    } else {
      const childPos = getTokenInlinePosition(child);
      if (childPos) {
        currentPos = childPos[1] + 1;
      }
      newChildren.push(child);
    }
  }

  return newChildren;
}

function processTableBody(index, tokens) {
  const tbodyToken = tokens[index];
  let currentLine = tbodyToken.map[0];
  for (let i = index + 1; i < tokens.length; i++) {
    if (tokens[i].type === 'tbody_close') {
      break;
    }

    if (tokens[i].type === 'tr_close') {
      currentLine++;
      continue;
    }

    if (tokens[i].type !== 'th_open' && tokens[i].type !== 'td_open') {
      tokens[i].map = [currentLine, currentLine + 1];
    }
  }
}

module.exports = function (md) {
  md.core.ruler.push('inject_token_marker', function injectTokenMarker(state) {
    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];
      const baseLine = token.map;
      if (baseLine && token.children) {
        token.children = injectTextWrapperToChildren(baseLine[0], token.children);
      }

      if (token.block && token.tag && token.nesting >= 0 && baseLine) {
        token.attrPush(['data-md-block', `${encodeNumberToInject(baseLine[0])},${encodeNumberToInject(baseLine[1] - 1)}`]);
      }

      if (token.type === 'tbody_open') {
        processTableBody(i, state.tokens);
      }
    }
  });
};
